import { Injectable } from '@angular/core';
import { Department } from './department.model';
import { ODataService } from '../../../core/services/oData.service';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService  extends ODataService<Department> {
  public url = 'Department';
}